import { Nav } from "react-bootstrap";
import { AllTermconditionContent } from "../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

const privacySections = [
  { id: "1", title: "Acceptance of Terms" },
  { id: "2", title: "Eligibility" },
  { id: "3", title: "Account Registration & Activation" },
  { id: "4", title: "Products & Usage" },
  { id: "5", title: "Orders, Pricing & Payments" },
  { id: "6", title: "Shipping & Delivery" },
  { id: "7", title: "Referral & Reward Program" },
  { id: "8", title: "Returns, Refunds & Cancellations" },
  { id: "9", title: "Prohibited Activities" },
  { id: "10", title: "Limitation of Liability" },
  { id: "11", title: "Intellectual Property" },
  { id: "12", title: "Termination of Services" },
  { id: "13", title: "Changes to Terms" },
  { id: "14", title: "Governing Law" },
];

function PrivacySidebar({ activeTab, setActiveTab }) {
  const dispatch = useDispatch();

  const all_terms_condition_content = useSelector(
    (state) => state?.common?.all_terms_condition_content,
  );

  useEffect(() => {
    dispatch(AllTermconditionContent());
    // dispatch(AllPrivacyPolicy());
  }, [dispatch]);
  const handleSelect = (selectedKey) => {
    setActiveTab(selectedKey);

    const element = document.getElementById(selectedKey);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <Nav
      className=" privacy-nav terms-conditions-nav px-4"
      activeKey={activeTab}
      onSelect={handleSelect}
    >
      <h5>Content Of Table</h5>

      {all_terms_condition_content?.map((item) => (
        <Nav.Link key={item?.id} eventKey={item?.id}>
          {item?.id}. {item?.name}
        </Nav.Link>
      ))}
    </Nav>
  );
}

export default PrivacySidebar;
